import { action, makeObservable, observable } from 'mobx';
import { IRound } from '../interfaces/round';
import { RoundStatus } from '../enums/round-status';

class RoundStore {

  checkHashRound: IRound | null = null;
  countDownDistance: number = 30000;
  roundId!: number;
  roundStatus!: RoundStatus;
  openedNumbers: number[] = [];

  constructor() {
    makeObservable(this, {
      roundStatus: observable,
      openedNumbers: observable,
      countDownDistance: observable,
      checkHashRound: observable,
      setCheckHashRound: action,
      setCountDownDistance: action,
      setRoundStatus: action,
      addOpenedNumber: action,
      clearOpenedNumbers: action,
      setOpenedNumber: action,
    });
  }

  setCheckHashRound = (round: IRound | null) => {
    this.checkHashRound = round;
  }

  setCountDownDistance = (distance: number) => {
    this.countDownDistance = distance;
  }

  setRoundStatus = (status: RoundStatus) => {
    this.roundStatus = status;
  }

  setOpenedNumber = (numbers: number[]) => {
    this.openedNumbers = numbers;
  }

  addOpenedNumber = (number: number) => {
    this.openedNumbers.push(number);
  }

  clearOpenedNumbers = () => {
    this.openedNumbers = [];
  }

  setRoundId = (id: number) => {
    this.roundId = id;
  }

}

export const roundStore = new RoundStore();
